//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockTransMenu', {
//        templateUrl: 'views/components/views/stockTransMenu/stockTransMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'stockTransMenuService', function ($stateParams, stateService, utilityService, stockTransMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockTransKeyno = $stateParams.stocktrans_keyno;
            
//            vm.model = {
//                requisitionNoButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('requisition', { requisition_no: vm.model.menu.requisition_no }) }
//                ],
//                orderOrderNoButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.menu.order_internal_no }) }
//                ],
//                purchOrderNoButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('purchhead', { purch_internal_no: vm.model.menu.purch_internal_no }) }
//                ],
//                menu: {},
//                itemsListAllocations: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadMenu() {
//                vm.model.menu = (await stockTransMenuService.getMenu({ stocktrans_keyno: stockTransKeyno }))[0];
//            }
            
//            async function loadAllocations() {
//                if (utilityService.validateParmsValue(vm.model.menu.stocktrans_keyno) !== true) return;
                
//                return vm.model.itemsListAllocations = await stockTransMenuService.listAllocations({ stocktrans_keyno: vm.model.menu.stocktrans_keyno });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadMenu();
//                loadAllocations();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
